<template>
  <transition name="fade" css="false" @before-enter="beforeEnter" @enter="enter" @leave="leave">
    <div v-if="showModal">
      <div class="modal" :class="{ 'd-block': showModal }" id="productModal" tabindex="-2" role="dialog"
           aria-labelledby="productModalLabel" aria-hidden="true">
        <div class="modal-dialog" role="document" style="max-width: 750px; margin-left: 280px;">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="productModalLabel">
                {{ this.orderIsEditable ? 'Редактировать' : 'Создать' }} Заказ
              </h5>
              <div v-if="!this.orderIsEditable" class="form-nav-buttons">
                <argon-button
                    variant="fill"
                    color="primary"
                    type="submit"
                    style="margin-top: 5px;"
                    @click="createOrder"
                    :disabled="!checkCreateOrder()"
                >
                  Создать
                </argon-button>
              </div>
              <b-button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="closeModal">
                <span aria-hidden="true">&times;</span>
              </b-button>
            </div>

            <div class="modal-body">
              <transition name="fade" css="false" @before-enter="beforeEnter" @enter="enter" @leave="leave">
                <div v-if="this.orderDataIsLoading">
                  <CircleProgress/>
                </div>
              </transition>

              <div v-if="!orderDataIsLoading">
                <h6>Заказ</h6>

                <div class="order-block">
                  <div class="input-container">
                    <label for="orderStatus">Статус</label>
                    <select
                        id="orderStatus"
                        style="max-width: 100%; border: 1px solid #d2d6da; color: #495057; border-radius: 0.5rem; font-size: 0.85rem; padding: 0.5rem 0.75rem;"
                        v-model="orderStatus"
                        @change="updateOrderStatus"
                    >
                      <option :key="1" :value="1">Бронь</option>
                      <option :key="2" :value="2">Активный</option>
                      <option :key="3" :value="3">Выполнен</option>
                    </select>
                  </div>

                  <div style="display: flex; align-items: center; max-width: 310px; width: 100%;">
                    <div class="input-container" style="max-width: 300px; width: 100%;">
                      <label for="client">Клиент</label>
                      <ClientSelect
                          id="client"
                          :model-value="client"
                          placeholder="Выберите клиента"
                          @update:modelValue="setOrderClientId"
                      />
                    </div>

                    <a
                        v-if="this.client != null"
                        style="margin-left: 15px; margin-top: 21px;"
                        href="javascript:;"
                        @click="blockClient(client)"
                    >
                      <i class="fas fa-ban text-warning"></i>
                    </a>
                  </div>
                </div>

                <div style="display: flex; align-items: center; justify-content: space-between;">
                  <div style="display: flex; align-items: center">
                    <div class="input-count">
                      <label for="shipment">Доставка</label>
                      <argon-input
                          id="shipment"
                          placeholder="Доставка"
                          type="number"
                          v-model="orderShipment"
                          :value="orderShipment"
                          @input="setOrderShipment"
                      />
                    </div>
                    <div style="margin-left: 10px; margin-top: 27px;">BYN</div>
                  </div>

                  <div style="display: flex; align-items: center">
                    <div class="input-count">
                      <label for="installation">Установка</label>
                      <argon-input
                          id="installation"
                          placeholder="Установка"
                          type="number"
                          v-model="orderInstallation"
                          :value="orderInstallation"
                          @input="setOrderInstallation"
                      />
                    </div>
                    <div style="margin-left: 10px; margin-top: 27px;">BYN</div>
                  </div>

                  <div style="display: flex; align-items: center">
                    <div class="input-count">
                      <label for="assembly">Сушка + Чистка</label>
                      <argon-input
                          id="assembly"
                          placeholder="Сборка"
                          type="number"
                          v-model="orderAssembly"
                          :value="orderAssembly"
                          @input="setOrderAssembly"
                      />
                    </div>
                    <div style="margin-left: 10px; margin-top: 27px;">BYN</div>
                  </div>
                </div>

                <div class="order-block">
                  <div class="input-container">
                    <label for="from">Начало</label>
                    <input
                        class="date-block"
                        v-model="createOrderFrom"
                        @input="selectFrom"
                        id="from"
                        type="date"
                        placeholder="Начало"
                    />
                  </div>

                  <div style="margin-top: 28px; font-weight: bold; border: 1px solid #5e72e4; padding: 5px; border-radius: 5px;">
                    {{ getDaysDifference(this.createOrderFrom, this.createOrderTo) }} ДНЕЙ
                  </div>

                  <div class="input-container">
                    <label for="to">Конец</label>
                    <input
                        class="date-block"
                        v-model="createOrderTo"
                        @input="selectTo"
                        id="to"
                        type="date"
                        placeholder="Конец"
                    />
                  </div>
                </div>

                <argon-button
                    variant="fill"
                    color="primary"
                    style="margin-top: 16px;"
                    full-width
                    :disabled="addProductModal"
                    @click="openOrderAddProductModal"
                    type="button"
                >
                  Добавить товары
                </argon-button>

                <table class="products-preview">
                  <thead>
                  <tr>
                    <th>Продукт</th>
                    <th>Количество</th>
                    <th>Скидка</th>
                    <th>Цена</th>
                    <th>Цена со скидкой</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="(item, index) in productOrderItems" :key="index" :class="{ 'not-found-row': getProductNameById(item.productId) === 'Продукт не найден' }">
                    <td>{{ getProductNameById(item.productId) }}</td>
                    <td>
                      <input class="order-qty" type="number" v-model="item.quantity" min="0" max="100">
                    </td>
                    <td>
                      <input class="order-discount" type="number" v-model="item.discount" min="0" max="100">%
                    </td>
                    <td>{{ getPriceWithoutDiscount(item.productId, item.quantity) }} BYN</td>
                    <td>{{ getTotalPrice(item) }} BYN</td>
                    <td>
                      <a href="javascript:;" @click="removeProductFromOrder(index)">
                        <i class="fas fa-trash"></i>
                      </a>
                    </td>
                    <td v-if="this.orderIsEditable">
                      <a href="javascript:;" @click="confirmRepair(item.productId)" style="margin-left: 5px;">
                        <i class="fas fa-tools"></i>
                      </a>
                    </td>
                  </tr>
                  </tbody>
                </table>

                <div v-if="this.orderIsEditable">
                  <div class="sub-total" v-if="this.deposit != null && this.deposit != 0">
                    ЗАЛОГ: {{ this.deposit.toFixed(2) }} BYN
                  </div>

                  <div class="sub-total" v-if="this.deposit != 0">
                    <argon-button
                        variant="fill"
                        color="primary"
                        style="font-size: 0.7rem; padding: 7px;"
                        @click="generateDopSogl"
                        type="button"
                    >
                      Доп соглашение
                    </argon-button>
                  </div>

                  <div class="sub-total" v-if="this.orderShipment != null && this.orderShipment != 0">
                    ДОСТАВКА: {{ this.orderShipment.toFixed(2) }} BYN
                  </div>

                  <div class="sub-total" v-if="this.orderAssembly != null && this.orderAssembly != 0">
                    СУШКА + ЧИСТКА: {{ this.orderAssembly.toFixed(2) }} BYN
                  </div>

                  <div class="sub-total" v-if="this.orderInstallation != null && this.orderInstallation != 0">
                    УСТАНОВКА: {{ this.orderInstallation.toFixed(2) }} BYN
                  </div>
                </div>

                <div style="margin-top: 16px;" v-if="productOrderItems.length != 0">
                  ИТОГО: {{ getOrderTotalPriceWithoutDiscount() }} BYN
                </div>

                <div style="margin-top: 16px;" v-if="productOrderItems.length != 0">
                  С УЧЕТОМ СКИДКИ: {{ getOrderTotalPrice() }} BYN
                </div>

                <label for="orderDiscount" style="font-weight: bold; margin-top: 16px;">Общая скидка</label>

                <div class="row-input">
                  <argon-input
                      style="max-width: 140px;"
                      id="orderDiscount"
                      placeholder="Общая скидка"
                      type="number"
                      v-model="orderDiscount"
                      :value="orderDiscount"
                      @input="setCustomDiscount"
                      min="0"
                      max="100"
                  />
                  <argon-button
                      variant="fill"
                      color="primary"
                      type="submit"
                      style="margin-left: 25px;"
                      @click="recalulateDiscount"
                  >
                    Применить
                  </argon-button>
                </div>

                <div class="row-input">
                  <div style="display: flex; align-items: center">
                    <div class="input-count">
                      <label for="deposit">Залог</label>
                      <argon-input
                          id="deposit"
                          placeholder="Залог"
                          type="number"
                          v-model="deposit"
                          :value="deposit"
                          @input="setOrderDeposit"
                      />
                    </div>
                    <div style="margin-left: 10px; margin-top: 27px;">BYN</div>
                  </div>

                  <div style="display: flex; align-items: center; margin-left: 25px">
                    <div class="input-count">
                      <label for="paidFor">Оплачено</label>
                      <argon-input
                          id="paidFor"
                          placeholder="Оплачено"
                          type="number"
                          v-model="orderPaidFor"
                          :value="orderPaidFor"
                          @input="updateOrderPaidFor"
                      />
                    </div>
                    <div style="margin-left: 10px; margin-top: 27px;">BYN</div>
                    <argon-button
                        variant="fill"
                        color="primary"
                        type="submit"
                        style="margin-top: 5px;"
                        @click="fullOplata"
                    >
                      Полная оплата
                    </argon-button>
                  </div>
                </div>
                <div v-if="this.orderIsEditable" class="form-nav-buttons">
                  <argon-button
                      variant="fill"
                      color="primary"
                      type="submit"
                      style="margin-top: 5px;"
                      @click="editOrder"
                      :disabled="!checkCreateOrder()"
                  >
                    Сохранить
                  </argon-button>

                  <argon-button
                      v-if="this.orderIsEditable"
                      variant="fill"
                      color="warning"
                      type="submit"
                      style="margin-top: 5px;"
                      @click="saveDefectContract"
                  >
                    Дефектный акт
                  </argon-button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <transition name="fade" css="false" @before-enter="beforeEnter" @enter="enter" @leave="leave">
          <div v-if="addProductModal">
            <div class="modal-product" :class="{ 'd-flex': addProductModal }" id="productAddModal" tabindex="-1"
                 role="dialog" aria-labelledby="productModalLabel" aria-hidden="true">
              <div role="document">
                <div class="modal-content"
                     style="border-top-left-radius: 0; border-bottom-left-radius: 0; border-left: none">
                  <div class="modal-body">
                    <transition name="fade" css="false" @before-enter="beforeEnter" @enter="enter" @leave="leave">
                      <div v-if="this.orderDataIsLoading">
                        <CircleProgress/>
                      </div>
                    </transition>

                    <div v-if="!orderDataIsLoading">
                      <div style="display: flex; justify-content: space-between">
                        <div style="width: 100%; display: flex; justify-content: space-between; align-items: center;">
                          <h6>Доступные товары</h6>
                          <argon-input
                              id="searchField"
                              placeholder="Поиск"
                              v-model="addProductSearchStr"
                              :value="addProductSearchStr"
                              style="margin-right: 10px;"
                              @input="searchProducts"
                              ref="searchField"
                          />
                        </div>

                        <b-button type="button" class="close" data-dismiss="modal" aria-label="Close"
                                  @click="closeOrderAddProductModal">
                          <span aria-hidden="true">&times;</span>
                        </b-button>
                      </div>

                      <div class="table-container">
                        <table class="products-preview">
                          <thead>
                          <tr>
                            <th>Продукт</th>
                            <th>Цена за единицу</th>
                            <th>Доступное количество</th>
                            <th>Количество</th>
                            <th></th>
                          </tr>
                          </thead>
                          <tbody>
                          <tr v-for="(item, index) in activeFilteredProducts" :key="index">
                            <td>{{ item.name }}</td>
                            <td style="font-weight: bold">{{ item.rentCost }} BYN</td>
                            <td style="font-weight: bold;">{{ availableCountProducts[item.id] }}</td>
                            <td>
                              <input
                                  type="number"
                                  min="0"
                                  :max="availableCountProducts[item.id]"
                                  style="max-width: 40px; width: 100%;"
                                  v-model="countControllers[index]"
                                  @input="updateProductCount(index, $event.target.value)"
                              >
                            </td>
                            <td>
                              <argon-button
                                  variant="fill"
                                  color="primary"
                                  style="font-size: 0.7rem; padding: 7px;"
                                  :disabled="countControllers[index] > availableCountProducts[item.id] || countControllers[index] <= 0"
                                  @click="addProductToOrder(index, item)"
                                  type="button"
                              >
                                Добавить
                              </argon-button>
                            </td>
                          </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </transition>
      </div>
    </div>
  </transition>
</template>

<script>
import axios from "@/axios";
import velocity from "velocity-animate";
import CircleProgress from "@/views/components/CircleProgress.vue";
import ArgonInput from "@/components/ArgonInput.vue";
import ArgonButton from "@/components/ArgonButton.vue";
import ClientSelect from "@/components/ClientSelect.vue";
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';

export default {
  name: "OrderEditorModal",
  components: {
    CircleProgress,
    ArgonInput,
    ArgonButton,
    ClientSelect
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    orderId: {
      type: [Number, String, null],
      default: null
    },
    repeatOrder: {
      type: [Object, null],
      default: null
    }
  },
  emits: ['close', 'saved'],
  data() {
    return {
      products: [],
      activeProducts: [],
      activeFilteredProducts: [],
      productCounts: []
    };
  },
  computed: {
    addProductSearchStr: {
      get() {
        return this.$store.state.addProductSearchStr;
      }
    },
    isRepeatMode() {
      return this.repeatOrder !== null && this.repeatOrder !== undefined;
    },
    orderInstallation: {
      get() {
        return this.$store.state.orderInstallation;
      }
    },
    orderPaidFor: {
      get() {
        return this.$store.state.orderPaidFor;
      }
    },
    orderShipment: {
      get() {
        return this.$store.state.orderShipment;
      }
    },
    orderAssembly: {
      get() {
        return this.$store.state.orderAssembly;
      }
    },
    availableCountProducts: {
      get() {
        return this.$store.state.availableCountProducts;
      }
    },
    countControllers: {
      get() {
        return this.$store.state.countControllers;
      }
    },
    addProductModal: {
      get() {
        return this.$store.state.orderProductModal;
      }
    },
    deposit: {
      get() {
        return this.$store.state.orderDeposit;
      }
    },
    orderIsEditable: {
      get() {
        return this.orderId !== null && this.orderId !== undefined;
      }
    },
    showModal: {
      get() {
        return this.show;
      }
    },
    orderDataIsLoading: {
      get() {
        return this.$store.state.orderDataIsLoading;
      }
    },
    orderStatus: {
      get() {
        return this.$store.state.createOrderStatus;
      }
    },
    client: {
      get() {
        return this.$store.state.createOrderClient;
      }
    },
    createOrderFrom: {
      get() {
        return this.$store.state.createOrderFrom;
      }
    },
    createOrderTo: {
      get() {
        return this.$store.state.createOrderTo;
      }
    },
    orderDiscount: {
      get() {
        return this.$store.state.createOrderDiscount;
      }
    },
    productOrderItems: {
      get() {
        return this.$store.state.createOrderItems;
      }
    },
    hasMissingProducts() {
      return this.productOrderItems.some((item) => this.getProductNameById(item.productId) === 'Продукт не найден');
    }
  },
  watch: {
    show(newValue) {
      if (newValue) {
        this.initializeModal();
      }
    },
    orderId() {
      if (this.show) {
        this.initializeModal();
      }
    }
  },
  methods: {
    async initializeModal() {
      this.clearOrderFields();
      this.closeOrderAddProductModal();

      if (!this.products.length) {
        await this.fetchProducts();
      }

      if (this.isRepeatMode) {
        this.fillOrderFromRepeatData(this.repeatOrder);
        return;
      }

      if (!this.orderId) {
        const today = new Date();

        const from = new Date(today);
        const to = new Date(today);

        if (today.getDay() === 5) {
          to.setDate(today.getDate() + 3);
        } else {
          to.setDate(today.getDate() + 1);
        }

        const format = (date) => date.toISOString().split('T')[0];

        this.setCreateOrderFrom(format(from));
        this.setCreateOrderTo(format(to));

        return;
      }

      this.loadOrder(this.orderId);
    },
    fillOrderFromRepeatData(order) {
      this.$store.commit('updateOrderDataIsLoading', true);

      axios.get('/api/order/' + order.id)
          .then((response) => {
            var order = response.data;

            this.$store.commit('updateCreateOrderClient', order.clientId);

            const today = new Date();

            const rentStart = new Date(today);
            const rentEnd = new Date(today);

            if (today.getDay() === 5) {
              rentEnd.setDate(today.getDate() + 3);
            } else {
              rentEnd.setDate(today.getDate() + 1);
            }

            const format = (date) => date.toISOString().split('T')[0];
            order.status = 2;
            this.$store.commit('updateCreateOrderFrom', format(rentStart));
            this.$store.commit('updateCreateOrderTo', format(rentEnd));
            this.$store.commit('updateCreateOrderDiscount', order.discount || 0);
            this.$store.commit('updateOrderDeposit', Number(order.securityDepositAmount || 0));
            this.$store.commit('updateOrderShipment', Number(order.delivery || 0));
            this.$store.commit('updateOrderAssembly', Number(order.sborka || 0));
            this.$store.commit('updateOrderInstallation', Number(order.ustanovka || 0));
            this.$store.commit('updateOrderPaidFor', Number(order.oplacheno || 0));
            this.$store.commit('updateCreateProductItems', order.orderItems || []);
            this.$store.commit('setUpdateOrderData', order);
            this.$store.commit('updateUpdateOrderId', null);
          })
          .catch((error) => {
            console.error('Ошибка загрузки заказа:', error);
          })
          .finally(() => {
            this.$store.commit('updateOrderDataIsLoading', false);
          });
    },
    loadOrder(orderId) {
      this.$store.commit('updateOrderDataIsLoading', true);

      axios.get('/api/order/' + orderId)
          .then((response) => {
            var order = response.data;

            this.$store.commit('updateOrderStatus', order.status);
            this.$store.commit('updateCreateOrderClient', order.clientId);
            const rentStart = order.rentStartDate?.date
                ? order.rentStartDate.date.slice(0, 10)
                : null;

            const rentEnd = order.rentEndDate?.date
                ? order.rentEndDate.date.slice(0, 10)
                : null;

            this.$store.commit('updateCreateOrderFrom', rentStart);
            this.$store.commit('updateCreateOrderTo', rentEnd);
            this.$store.commit('updateCreateOrderDiscount', order.discount || 0);
            this.$store.commit('updateOrderDeposit', Number(order.securityDepositAmount || 0));
            this.$store.commit('updateOrderShipment', Number(order.delivery || 0));
            this.$store.commit('updateOrderAssembly', Number(order.sborka || 0));
            this.$store.commit('updateOrderInstallation', Number(order.ustanovka || 0));
            this.$store.commit('updateOrderPaidFor', Number(order.oplacheno || 0));
            this.$store.commit('updateCreateProductItems', order.orderItems || []);
            this.$store.commit('setUpdateOrderData', order);
            this.$store.commit('updateUpdateOrderId', order.id);
          })
          .catch((error) => {
            console.error('Ошибка загрузки заказа:', error);
          })
          .finally(() => {
            this.$store.commit('updateOrderDataIsLoading', false);
          });
    },

    getProductsUrl() {
      const params = new URLSearchParams();

      if (this.createOrderFrom) {
        params.append('dateStart', this.createOrderFrom);
      }

      if (this.createOrderTo) {
        params.append('dateEnd', this.createOrderTo);
      }

      const query = params.toString();

      return query ? `/api/product/?${query}` : '/api/product/';
    },

    fetchProducts() {
      return axios.get(this.getProductsUrl()).then((response) => {
        this.products = response.data;
        this.activeProducts = this.products.filter((item) => item.active);
        this.activeFilteredProducts = this.activeProducts;
        this.createCountControllers();
        this.createAvailableProductCounts();
      }).catch((error) => {
        console.error("Ошибка загрузки товаров: ", error);
      });
    },

    async openOrderAddProductModal() {
      await this.fetchProducts();
      this.$store.commit('updateOrderProductModal', true);
      this.$nextTick(() => {
         if (this.$refs.searchField && this.$refs.searchField.$el) {
              const input = this.$refs.searchField.$el.querySelector('input');
             if (input) {
                 input.focus();
                  input.select();
                }
            }
        });
    },


    searchProducts(payload) {
      this.$store.commit('updateAddProductSearchStr', payload.target.value);
      this.activeFilteredProducts = this.activeProducts.filter((product) =>
          product.name.toLowerCase().includes(this.addProductSearchStr.toLowerCase())
      );

      var indices = this.activeFilteredProducts.map((filteredProduct) => filteredProduct.id);
      var newCounts = indices.reduce((acc, id) => {
        acc[id] = this.productCounts[id];
        return acc;
      }, {});
      this.$store.commit('updateAvailableCountProducts', newCounts);
    },

    fullOplata() {
      var fullPrice = this.getOrderTotalPrice();
      this.$store.commit('updateOrderPaidFor', fullPrice);
    },

    getDaysDifference(date1, date2) {
      var d1 = new Date(date1);
      var d2 = new Date(date2);
      var diffInMilliseconds = Math.abs(d2 - d1);
      var diffInDays = Math.ceil(diffInMilliseconds / (1000 * 60 * 60 * 24));
      return diffInDays;
    },

    updateProductCount(index, value) {
      var newControllers = this.countControllers.slice();
      newControllers[index] = Number(value);
      this.$store.commit('updateCountControllers', newControllers);
    },

    recalulateDiscount() {
      var newProductOrderItems = this.productOrderItems.map((item) => {
        item.discount = this.orderDiscount;
        return item;
      });
      this.setCreateProductItems(newProductOrderItems);
    },

    deleteAvailableCounts(index, productId) {
      var newControllers = Object.assign({}, this.availableCountProducts);
      newControllers[productId] = newControllers[productId] - this.countControllers[index];
      this.productCounts[productId] = newControllers[productId];
      this.$store.commit('updateAvailableCountProducts', newControllers);
    },

    addAvailableCounts(index, value, productId) {
      var newControllers = Object.assign({}, this.availableCountProducts);
      newControllers[productId] = newControllers[productId] + value;
      this.productCounts[productId] = newControllers[productId];
      this.$store.commit('updateAvailableCountProducts', newControllers);
    },

    createCountControllers() {
      var controllers = this.activeProducts.map(() => 0);
      this.$store.commit('updateCountControllers', controllers);
    },

    createAvailableProductCounts() {
      var controllers = this.activeProducts.reduce((acc, product) => {
        acc[product.id] = product.dostupno;
        return acc;
      }, {});
      this.productCounts = controllers;
      this.$store.commit('updateAvailableCountProducts', controllers);
    },

    createOrder() {
      this.setIsLoading(true);

      var order = {
        status: this.orderStatus,
        clientId: this.client,
        paymentAmount: this.getOrderTotalPriceWithoutDiscount(),
        endPrice: this.getOrderTotalPrice(),
        discount: this.orderDiscount,
        securityDepositAmount: this.deposit,
        rentStartDate: this.createOrderFrom,
        rentEndDate: this.createOrderTo,
        sborka: this.orderAssembly,
        ustanovka: this.orderInstallation,
        orderItems: this.productOrderItems,
        delivery: this.orderShipment,
        oplacheno: this.orderPaidFor,
        isArenda: true
      };

      axios.post('/api/order/new', order).then(() => {
        this.setIsLoading(false);
        this.closeModal();
        this.$emit('saved');
      }).catch((error) => {
        console.error("Ошибка создания заказа: ", error);
        this.setIsLoading(false);
      });
    },

    editOrder() {
      var order = {
        status: this.orderStatus,
        clientId: this.client,
        paymentAmount: this.getOrderTotalPriceWithoutDiscount(),
        endPrice: this.getOrderTotalPrice(),
        discount: this.orderDiscount,
        securityDepositAmount: this.deposit,
        rentStartDate: this.createOrderFrom,
        rentEndDate: this.createOrderTo,
        sborka: this.orderAssembly,
        ustanovka: this.orderInstallation,
        orderItems: this.productOrderItems,
        delivery: this.orderShipment,
        oplacheno: this.orderPaidFor,
        isArenda: true
      };

      this.setIsLoading(true);

      axios.put('/api/order/' + this.orderId + '/update', order).then(() => {
        this.setIsLoading(false);
        this.closeModal();
        this.$emit('saved');
      }).catch((error) => {
        console.error("Ошибка редактирования заказа: ", error);
        this.setIsLoading(false);
      });
    },

    closeModal() {
      this.clearOrderFields();
      this.closeOrderAddProductModal();
      this.$store.commit('updateCreateOrderClient', null);
      this.$store.commit('updateOrderEditable', false);
      this.$emit('close');
    },

    checkCreateOrder() {
      return this.client !== null &&
          this.productOrderItems.length !== 0 &&
          this.createOrderFrom != null &&
          this.createOrderTo != null &&
          !this.hasMissingProducts;
    },

    addProductToOrder(index, item) {
      var existingOrderItem = this.productOrderItems.find((orderItem) => orderItem.productId === item.id);

      if (existingOrderItem) {
        existingOrderItem.quantity += this.countControllers[index];
      } else {
        this.productOrderItems.push({
          productId: item.id,
          quantity: this.countControllers[index],
          discount: this.orderDiscount
        });
      }

      var deposit = item.equipmentCost * this.countControllers[index];
      this.$store.commit('updateOrderDeposit', deposit + this.deposit);
      this.setCreateProductItems(this.productOrderItems);
      this.clearSingleProduct();
      this.deleteAvailableCounts(index, item.id);
      this.updateProductCount(index, 0);
    },

    getProductNameById(id) {
      for (var i = 0; i < this.products.length; i++) {
        if (this.products[i].id === id) {
          return this.products[i].name;
        }
      }
      return 'Продукт не найден';
    },

    getProductPriceById(id) {
      for (var i = 0; i < this.products.length; i++) {
        if (this.products[i].id == id) {
          return this.products[i].rentCost;
        }
      }
      return 0;
    },

    getTotalPrice(item) {

      var price = item.price ?? this.getProductPriceById(item.productId);

      var totalPrice =
          item.quantity *
          price *
          this.getDaysDifference(this.createOrderFrom, this.createOrderTo);

      if (item.discount) {
        totalPrice = totalPrice * (1 - (item.discount / 100));
      }

      return totalPrice.toFixed(2);
    },

    getPriceWithoutDiscount(id, count) {
      var price = this.getProductPriceById(id);
      var totalPrice = count * price * this.getDaysDifference(this.createOrderFrom, this.createOrderTo);
      return totalPrice.toFixed(2);
    },

    blockClient(id) {
      if (confirm("Вы уверены, что хотите внести клиента в черный список?")) {
        var reason = prompt("Пожалуйста, введите причину:");
        this.addToBlacklist(id, reason);
      }
    },

    addToBlacklist(id, reason) {
      axios.post('/api/clients/add-to-blacklist/' + id, { reason: reason }).then(() => {
        this.$store.commit('updateCreateOrderClient', null);
      });
    },

    setDocIsLoading(active) {
      this.$store.commit('updateIsDocLoading', active);
    },

    generateDopSogl() {
      var currentOrderId = this.orderId;
      this.setDocIsLoading(true);

      axios.get('/api/order/' + currentOrderId + '/generate-legal-dop-sogl', {
        responseType: 'blob'
      }).then((response) => {
        var url = window.URL.createObjectURL(new Blob([response.data]));
        var link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'dop_soglashenie' + currentOrderId + '.docx');
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }).catch((error) => {
        console.error('Error generating legal contract:', error);
      });

      this.setDocIsLoading(false);
    },

    getOrderTotalPriceWithoutDiscount() {
      var totalPrice = 0;

      for (var i = 0; i < this.productOrderItems.length; i++) {
        totalPrice += Number(this.getPriceWithoutDiscount(
            this.productOrderItems[i].productId,
            this.productOrderItems[i].quantity
        ));
      }

      totalPrice = totalPrice + this.deposit + this.orderShipment + this.orderAssembly + this.orderInstallation;
      return totalPrice.toFixed(2);
    },

    getOrderTotalPrice() {
      var totalPrice = 0;

      for (var i = 0; i < this.productOrderItems.length; i++) {
        totalPrice += Number(this.getTotalPrice(this.productOrderItems[i]));
      }

      totalPrice = totalPrice + this.deposit + this.orderShipment + this.orderAssembly + this.orderInstallation;
      return totalPrice.toFixed(2);
    },

    removeProductFromOrder(index) {
      this.addAvailableCounts(
          index,
          this.productOrderItems[index].quantity,
          this.productOrderItems[index].productId
      );
      this.productOrderItems.splice(index, 1);
      this.setCreateProductItems(this.productOrderItems);
    },

    selectTo(date) {
      this.setCreateOrderTo(date);
      if (this.createOrderFrom !== null) {
        this.countDaysDifference();
      }
    },

    selectFrom(date) {
      this.setCreateOrderFrom(date);

      const fromDate = new Date(date.target.value);

      const nextDate = new Date(fromDate);

      if (fromDate.getDay() === 5) {
        nextDate.setDate(fromDate.getDate() + 3);
      } else {
        nextDate.setDate(fromDate.getDate() + 1);
      }

      const formatted = nextDate.toISOString().split('T')[0];
      this.setCreateOrderTo(formatted);

      if (this.createOrderTo !== null) {
        this.countDaysDifference();
      }
    },

    countDaysDifference() {
      var dateFrom = new Date(this.createOrderFrom);
      var dateTo = new Date(this.createOrderTo);
      var diffTime = Math.abs(dateTo - dateFrom);
      var diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

      this.setDayDifference(diffDays);
      this.calculateDiscountOrMarkup(diffDays);
    },

    calculateDiscountOrMarkup(days) {
      axios.get('/api/discount/list')
          .then((response) => {
            var rules = response.data.slice().sort((a, b) => a.days - b.days);
            var matchedRule = null;

            for (var i = 0; i < rules.length; i++) {
              if (rules[i].days <= days) {
                matchedRule = rules[i];
              } else {
                break;
              }
            }

            var percent = matchedRule ? matchedRule.percent : 0;
            this.setOrderDiscount(percent);
          })
          .catch((error) => {
            console.error('Error get percent values:', error);
          });
    },

    saveDefectContract() {
      axios.get('/api/order/' + this.orderId + '/generate-remont-act', {
        responseType: 'blob'
      }).then((response) => {
        var url = window.URL.createObjectURL(new Blob([response.data]));
        var link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'defect_contract' + this.orderId + '.docx');
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }).catch((error) => {
        console.error('Error generating legal contract:', error);
      });

      this.setDocIsLoading(false);
    },

    confirmRepair(id) {
      if (confirm("Вы уверены, что хотите отдать товар на ремонт?")) {
        var reason = prompt("Укажите причину:");
        this.createRepair(id, reason);
      }
    },

    createRepair(productId, reason) {
      var data = {
        productId: productId,
        description: reason
      };

      axios.post('/api/product/add-repair-list', data).catch((error) => {
        console.error("Ошибка создания ремонта: ", error);
      });
    },

    updateOrderPaidFor(sum) {
      var value = sum.target.value;
      if (value === '' || !isNaN(value)) {
        this.$store.commit('updateOrderPaidFor', value);
      }
    },

    closeOrderAddProductModal() {
      this.$store.commit('updateOrderProductModal', false);
      this.$store.commit('updateAddProductSearchStr', "");
      this.$store.commit('updateAvailableCountProducts', this.productCounts);
      this.activeFilteredProducts = this.activeProducts;
    },

    updateOrderStatus(payload) {
      this.$store.commit('updateOrderStatus', payload.target.value);
    },

    setOrderClientId(clientId) {
      this.$store.commit('updateCreateOrderClient', clientId);
    },

    setCreateOrderFrom(date) {
      const value = date?.target ? date.target.value : date;
      this.$store.commit('updateCreateOrderFrom', value);
    },

    setCreateOrderTo(date) {
      const value = date?.target ? date.target.value : date;
      this.$store.commit('updateCreateOrderTo', value);
    },

    setDayDifference(diff) {
      this.$store.commit('updateDayDifference', diff);
    },

    setOrderDiscount(discount) {
      if (discount >= 0 && discount <= 100) {
        this.$store.commit('updateCreateOrderDiscount', discount);
      }
    },

    clearSingleProduct() {
      this.$store.commit('clearSingleCreateProduct');
    },

    setCreateProductItems(product) {
      this.$store.commit('updateCreateProductItems', product);
    },

    clearOrderFields() {
      this.$store.commit('clearOrderData');
    },

    setIsLoading(active) {
      this.$store.commit('updateIsOrderDataLoading', active);
    },

    setOrderDeposit(deposit) {
      this.$store.commit('updateOrderDeposit', Number(deposit.target.value));
    },

    setOrderShipment(shipment) {
      this.$store.commit('updateOrderShipment', Number(shipment.target.value));
    },

    setOrderAssembly(assembly) {
      this.$store.commit('updateOrderAssembly', Number(assembly.target.value));
    },

    setOrderInstallation(installation) {
      this.$store.commit('updateOrderInstallation', Number(installation.target.value));
    },

    setCustomDiscount(customDiscount) {
      this.setOrderDiscount(Number(customDiscount.target.value));
    },

    beforeEnter(el) {
      el.style.opacity = 0;
    },

    enter(el, done) {
      velocity(el, { opacity: 1 }, { duration: 500, complete: done });
    },

    leave(el, done) {
      velocity(el, { opacity: 0 }, { duration: 500, complete: done });
    }
  },

  mounted() {
    this.fetchProducts();
  }
};
</script>

<style scoped>
.date-block {
  border: 1px solid #d2d6da;
  color: #495057;
  border-radius: 0.5rem;
  padding: 0.5rem 0.75rem;
}

.input-container {
  max-width: 300px;
  width: 100%;
  display: flex;
  flex-direction: column;
}

.order-block {
  display: flex;
  justify-content: space-between;
  margin-top: 16px;
  align-items: center;
}

.input-count {
  margin-top: 10px;
  max-width: 120px;
  width: 100%;
}

.products-preview {
  margin-top: 16px;
  width: 100%;
}

td, th {
  width: auto;
  font-size: 0.8rem;
}

.row-input {
  display: flex;
  align-items: start;
}

.order-discount {
  max-width: 70px;
}

.modal {
  z-index: 1001;
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}

.modal-product {
  z-index: 1002;
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100vh;
  background-color: #00000094;
  display: flex !important;
  align-items: center;
  justify-content: center;
}

.table-container {
  max-height: 300px;
  overflow-y: auto;
  padding-right: 5px;
}

.sub-total {
  margin-top: 8px;
  font-size: 0.8rem;
  font-weight: 600;
}

.form-nav-buttons {
  display: flex;
  justify-content: space-between;
}
.not-found-row {
  background-color: #ffe5e5;
  color: #dc3545;
  font-weight: bold;
}
</style>
